<div class="properties-container">
  <!--Options List -->
  <div class="options-sidebar">
    <div class="sidebar-header">
      <label>Properties</label>
    </div>

    <mat-list class="options-list">
      <ng-container *ngFor="let option of propertyOptions; trackBy: trackById">
        <mat-list-item *ngIf="isTabVisible(option.id)" (click)="selectOption(option.id)"
          [class.selected]="selectedOptionId === option.id" class="option-item">
          <div matListItemTitle>{{option.label | translate}}</div>
        </mat-list-item>
      </ng-container>
    </mat-list>
  </div>

  <!-- Content Area -->
  <div class="content-area">
    <div class="content-header">
      <div class="header-info">
        <label>{{getSelectedOption()?.label | translate}}</label>
      </div>
    </div>

    <mat-divider></mat-divider>

    <div class="content-body" [ngSwitch]="selectedOptionId">
      @if(isDataLoaded()){
      <!-- Estimate Settings Content -->
      <div *ngSwitchCase="propertiesOptionId.ESTIMATE_SETTINGS" class="settings-section">
        <app-sol-properties-estimate-settings></app-sol-properties-estimate-settings>
      </div>

      <!-- Estimate Collaboration Content -->
      <div *ngSwitchCase="propertiesOptionId.ESTIMATE_COLLABORATION" class="settings-section">
        <app-sol-properties-estimate-collaboration></app-sol-properties-estimate-collaboration>
      </div>

      <!-- Estimate Install Type Content -->
      <div *ngSwitchCase="propertiesOptionId.ESTIMATE_INSTALL_TYPE" class="settings-section">
        <app-sol-properties-estimate-install-type></app-sol-properties-estimate-install-type>
      </div>

      <!-- Estimate Statistics Content -->
      <div *ngSwitchCase="propertiesOptionId.ESTIMATE_STATISTICS" class="settings-section">
        <app-sol-properties-estimate-statistics></app-sol-properties-estimate-statistics>
      </div>

      <!-- Electrical Services Content -->
      <div *ngSwitchCase="propertiesOptionId.ELECTRICAL_SERVICES" class="settings-section">
        <app-sol-properties-electrical-services></app-sol-properties-electrical-services>
      </div>

      <!-- Sizing Settings Content -->
      <div *ngSwitchCase="propertiesOptionId.SIZING_SETTINGS" class="settings-section">
        <app-sol-properties-sizing-settings></app-sol-properties-sizing-settings>
      </div>

      <!-- Task Based Labor Content -->
      <div *ngSwitchCase="propertiesOptionId.TASK_BASED_LABOR" class="settings-section">
        <app-sol-properties-task-based-labor></app-sol-properties-task-based-labor>
      </div>

      <!-- Travel Settings Content -->
      <div *ngSwitchCase="propertiesOptionId.TRAVEL_SETTINGS" class="settings-section">
        <app-sol-properties-travel-settings></app-sol-properties-travel-settings>
      </div>

      <!-- Tax Settings Content -->
      <div *ngSwitchCase="propertiesOptionId.TAX_SETTINGS" class="settings-section">
        <app-sol-properties-tax-settings></app-sol-properties-tax-settings>
      </div>

      <!-- Labor Rates Content -->
      <div *ngSwitchCase="propertiesOptionId.LABOR_RATES" class="settings-section">
        <app-sol-properties-labor-rates></app-sol-properties-labor-rates>
      </div>

      <!-- Overtime Rates Content -->
      <div *ngSwitchCase="propertiesOptionId.OVERTIME_RATES" class="settings-section">
        <app-sol-properties-overtime-rates></app-sol-properties-overtime-rates>
      </div>

      <!-- Proposal Content -->
      <div *ngSwitchCase="propertiesOptionId.PROPOSAL" class="settings-section">
        <app-sol-properties-proposal></app-sol-properties-proposal>
      </div>

      <!-- Proposal Customer Info Content -->
      <div *ngSwitchCase="propertiesOptionId.PROPOSAL_CUSTOMER_INFO" class="settings-section">
        <app-sol-properties-proposal-customer-info></app-sol-properties-proposal-customer-info>
      </div>
      }
    </div>

    <div class="content-footer">
      <button mat-raised-button color="primary">{{'HELP' | translate}}</button>
      <button mat-raised-button color="primary" (click)="save()">{{ 'OK' | translate}}</button>
      <button mat-raised-button color="warn" (click)="cancelSelection()">{{'CANCEL' | translate}}</button>
    </div>
  </div>
</div>